import { ScreenHelper } from "./screenHelper";

export class ScrollHelper {
    public static stickyElementOnScroll(scrollY: any, elements: any[], top: any): void {
        if (ScreenHelper.isPhone())
            return;
        if (scrollY.target.scrollTop > top) {
            elements.forEach(el => {
                el.classList.add('sticky');
            });
            return;
        }

        elements.forEach(el => {
            el.classList.remove('sticky');
        })
    };

    /**
      * Force vertical scroll to be shown.
      * Used on pages were vertical scroll is needed and it cannot be achived via styles.
      * By some reason, 'overflow' style value is overwritten by body. 
      */
    public static forceSetVerticalScroll(element: any): void {
        element.style.overflowY = 'scroll';
    }
}


// WEBPACK FOOTER //
// ./app/common/helpers/scrollHelper.ts